export const truncate = (string: string, n: number) => {
  if (string) {
    const truncatedString =
      string.length > n ? `${string.substring(0, n - 1)}...` : string;
    return truncatedString;
  }
  return '';
};
